import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconMicrophoneSvg } from "./IconMicrophoneSvg.mjs";
const IconMicrophone = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconMicrophoneSvg, ...svgProps }) });
export {
  IconMicrophone
};
